import { useEffect, useState } from "react";

type ElementBounds = { height: number; top: number };

export const isTopFractionInView = (
  { height, top }: ElementBounds,
  viewportHeight: number,
  fraction: number,
) => {
  return top + height * fraction <= viewportHeight;
};

export const useIsTopFractionInView = (target: HTMLElement | null, fraction: number) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!target) {
      setIsInView(false);

      return undefined;
    }

    let frame = 0;

    const update = () => {
      frame = 0;
      setIsInView(
        isTopFractionInView(target.getBoundingClientRect(), window.innerHeight, fraction),
      );
    };

    const schedule = () => {
      if (frame === 0) {
        frame = requestAnimationFrame(update);
      }
    };

    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
    };
  }, [target, fraction]);

  return isInView;
};
